<template>
  <footer class="app-footer">
    © 2011–{{ new Date().getFullYear() }} {{ $appInfo.title }} Inc. · Semua merek dagang adalah milik pemiliknya masing-masing.
  </footer>
</template>

<style>
.app-footer {
  padding: 16px 16px 20px;
  font-size: 12px;
  color: var(--text-muted);
  text-align: center;
}
</style>
